<template>
  <div v-loading="loading">
    <div v-if="!open" style="height: 500px">商家暂未加入平台化服务。</div>
    <!-- 平台化设置 -->
    <el-form v-if="open" :model="form" label-width="140px">
      <el-form-item label="是否平台化商家">
        <el-select v-model="form.is_platform">
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
        <div v-show="form.is_platform == 0" style="color: red; display: inline">
          “关闭”平台化服务并提交后，下面所有设置也同时为关闭、失效。
        </div>
      </el-form-item>

      <el-form-item label="平台化等级">
        <el-select v-model="form.sale_level" :disabled="closePf">
          <el-option
            v-for="item in sale_levels"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div style="color: #888; display: inline">
          系统每月根据商家表现自动调整等级，手动修改只对当前自然月生效。
        </div>
      </el-form-item>

      <el-form-item label="一手APP是否展示“严选品牌”标签" required>
        <el-select v-model="form.is_show_best_choice" :disabled="closePf">
          <el-option label="展示" value="1"></el-option>
          <el-option label="不展示" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="合同模式" required>
        <el-select v-model="form.contract_type_id" :disabled="closePf">
          <el-option
            v-for="item in contract_type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <div style="border: 1px solid #ccc">
        <div
          style="
            background-color: #f8f8f8;
            border-bottom: 1px solid #ccc;
            padding: 5px 10px;
          "
        >
          <el-form-item label="平台佣金扣取" style="margin-bottom: 0">
            <el-select v-model="form.platform_switch" :disabled="closePf">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="padding: 20px">
          <el-form-item label="平台协议日期">
            <el-date-picker
              v-model="form.platform_begin_time"
              value-format="yyyy-MM-dd"
              :disabled="disabledPlatform"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <p
              v-show="!disabledPlatform && form.platform_begin_time"
              style="display: inline; color: #888"
            >
              从<span style="color: blue">{{ toDay }} 7:00</span
              >的专场开始享受到平台化商家政策流量，代采开单将对计划生成时间从<span
                style="color: blue"
                >{{ nextDay }} 7:00</span
              >开始，进行平台佣金的代采订单扣费。
            </p>
          </el-form-item>

          <el-form-item label="平台佣金比例(%)">
            <el-inputNumber
              v-model="form.service_fee_rate"
              :min="0.0"
              :max="100.0"
              :precision="2"
              style="width: 220px"
              :disabled="disabledPlatform"
            ></el-inputNumber>
          </el-form-item>
        </div>
      </div>

      <el-button
        type="primary"
        style="margin-top: 30px; margin-left: 160px"
        @click="submit"
        >提交</el-button
      >
    </el-form>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    supplyId: {
      type: String,
      default: "0",
    },
  },

  data() {
    return {
      loading: false,
      open: false,
      form: {
        supply_id: this.supplyId,
        is_platform: "1",
        sale_level: "",
        no_reason_return: "0",
        no_reason_begin_time: "",
        refund_model: "1",
        refund_service_fee_rate: 0.0,
        service_fee_rate: 0.0,
        return_limit_ratio: "",
        is_show_best_choice: "1", // 是否展示“严选品牌”标签
        contract_type_id: "", // 合同模式Id
        platform_switch: "2",
        platform_begin_time: "",
      },
      original_refund_service_fee_rate: 0.0,
      sale_levels: [],

      refund_models: [],
      contract_type: [], // 合同模式下拉选项

      pickerOptions: {
        disabledDate: (date) => date.getTime() < Date.now(),
      },
    };
  },

  computed: {
    // disabled = is_paltform == 0
    closePf() {
      return this.form.is_platform == 0;
    },

    toDay() {
      return dayjs(this.form.platform_begin_time).format("YYYY-MM-DD");
    },
    nextDay() {
      return dayjs(this.form.platform_begin_time)
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    disabledPlatform() {
      return this.form.platform_switch === "2";
    },
  },

  created() {
    // console.log('platform-created')
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.$post("/erp/Supply/getSupplyPlatformInfo", {
        supply_id: this.supplyId,
      }).then((rs) => {
        if (rs.is_platform == 1) {
          this.open = true;
        }
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in this.form) {
          this.form[key] = rs[key];
        }
        this.original_refund_service_fee_rate = rs.refund_service_fee_rate;
        this.sale_levels = rs.sale_levels;
        this.refund_models = rs.refund_models;
        this.contract_type = rs.contract_type;
      });
    },

    // 提交
    submit() {
      if (!this.closePf) {
        this._submit();
        return;
      }

      const confirmText = [
        "1.需确保代采已将订单处理完毕。",
        "2.保证金退回需线下联系财务处理。",
      ];
      const newData = [];
      const h = this.$createElement;
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const i in confirmText) {
        newData.push(h("p", null, confirmText[i]));
      }
      this.$confirm("是否确认退出平台化", {
        title: "是否确认退出平台化",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        showClose: false,
        message: h("div", null, newData),
      }).then(() => {
        this._submit();
      });
    },

    _submit() {
      this.loading = true;
      this.$post("/erp/Supply/saveSupplyPlatformInfo", this.form)
        .then(() => {
          this.$message.success("保存成功");
          // this.fetchData();
          this.$removeSelf(this);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/updateSupplyComponents/Platforming.vue